
define('text!templates/appMain/privilegedMain/supervisorListingView.html',[],function () { return '<!-- ko include: {\n    name: \'templates/appMain/privilegedMain/listContainerView\',\n    data: listContainerView\n} -->\n<!-- /ko -->';});

